/**
 * Locates the DOM node the application mounts into.
 *
 * Extracted out of `main.tsx` for the reason `docs/TESTING-STANDARDS.md` states under "Seams": a
 * module with top-level side effects cannot be imported by a test, and `main.tsx` calls
 * `createRoot(...).render(...)` at import time. The one branch that module owned - a missing mount
 * point - is the only thing worth extracting, the same split `apps/worker/src/main.ts` makes with
 * `shutdown.ts`.
 *
 * `document` is accepted as a parameter rather than read from the global so a test can supply a
 * fake without a DOM: this project's specs run under `environment: "node"` (`vitest.config.ts`),
 * where no global `document` exists at all.
 */
export function requireMountElement(
  document: Pick<Document, "getElementById">,
  id: string,
): HTMLElement {
  const element = document.getElementById(id);
  if (!element) {
    throw new Error(`Missing #${id} mount point in index.html`);
  }
  return element;
}
